var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollTopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_265",
    x: 0,
    y: 0,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.231
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scroll_top",
    "data-name": "scroll top",
    transform: "translate(-1199.5 -824.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1199.5, 824.5)",
    filter: "url(#Ellipse_265)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265-2",
    "data-name": "Ellipse 265",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(13.5 10.5)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11519",
    "data-name": "Path 11519",
    d: "M-1982.49,12454l9.5-9.5,9.5,9.5",
    transform: "translate(3214.99 -11586.995)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollTopCircle);
export default __webpack_public_path__ + "static/media/scrollTopCircle.bf59d4b0.svg";
export { ForwardRef as ReactComponent };